<template>
	<div class="match-filter">
		<button class="match-filter__button" @click="canShowBottomSheet = true">
			<span class="match-filter__button__label">
				{{ currentPeriod.name }}
			</span>

			<svg
				class="match-filter__button__caret"
				viewBox="0 0 6 4"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M2.87866 3.21484C2.92554 3.28516 2.99585 3.30859 3.07788 3.30859C3.14819 3.30859 3.21851 3.28516 3.2771 3.21484L5.55054 0.941406C5.59741 0.894531 5.63257 0.824219 5.63257 0.742188C5.63257 0.671875 5.59741 0.601562 5.55054 0.542969L5.29272 0.285156C5.23413 0.238281 5.16382 0.203125 5.09351 0.203125C5.01147 0.203125 4.94116 0.226562 4.89429 0.273438L3.07788 2.08984L1.26147 0.273438C1.20288 0.226562 1.13257 0.203125 1.06226 0.203125C0.980225 0.203125 0.909912 0.238281 0.863037 0.285156L0.605225 0.542969C0.546631 0.601562 0.523193 0.671875 0.523193 0.742188C0.523193 0.824219 0.546631 0.894531 0.605225 0.941406L2.87866 3.21484Z"
				/>
			</svg>
		</button>
		<bottom-sheet
			:ref="'bottomSheet'"
			v-if="canShowBottomSheet"
			@close="closeBottomSheet"
			@has-mounted="showBottomSheet"
		>
			<div class="match-filter__container">
				<div class="match-filter__group">
					<h3 class="match-filter__group__title">Which day?</h3>
					<div class="match-filter__group__actions">
						<button
							:class="{
								'match-filter__group__action': 1,
								active: period.id === currentPeriod.id,
							}"
							v-for="period in periods"
							:key="period.id"
							@click="apply(period)"
						>
							{{ period.name }}
						</button>
					</div>
				</div>
				<!-- <button class="match-filter__apply" @click="apply">
          Apply
        </button> -->
				<button class="match-filter__reset" @click="reset">Cancel</button>
			</div>
		</bottom-sheet>
	</div>
</template>

<script>
import BottomSheet from "../../Shared/BottomSheet.vue";
export default {
	components: { BottomSheet },
	data() {
		return {
			canShowBottomSheet: false,
		};
	},
	props: {
		periods: {
			type: Array,
			required: true,
			default: () => [],
		},
		currentPeriod: {
			type: Object,
			required: true,
			default: () => ({
				id: -1,
				name: "Today",
			}),
		},
	},
	methods: {
		apply(sort) {
			this.closeBottomSheet();
			this.$emit("change-current-period", sort);
			this.$emit("apply");
		},
		reset() {
			this.closeBottomSheet();
			// this.$emit("reset");
		},
		showBottomSheet() {
			this.canShowBottomSheet = true;
			this.$nextTick(() => {
				this.$refs.bottomSheet.setState("open");
			});
		},
		closeBottomSheet() {
			this.$refs.bottomSheet.setState("close");
			this.$nextTick(() => {
				this.canShowBottomSheet = false;
			});
		},
	},
};
</script>

<style lang="scss"></style>
